module.exports = __webpack_public_path__ + "static/media/03.966a4b7a.png";